module.exports = __webpack_public_path__ + "img/1665948886.91ad66be.jpeg";